import { reactive } from "vue";
export const eventBus = reactive({
  showLoginModal: null, //registro funcion
});
